import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { NewsletterSignup } from "./NewsletterSignup";

const LEGAL_LINKS = [
  { label: "Terms & Conditions", to: "/terms-and-conditions", testId: "footer-terms-link" },
  { label: "Privacy Policy", to: "/privacy-policy", testId: "footer-privacy-link" },
  { label: "Disclaimer of Use", to: "/disclaimer", testId: "footer-disclaimer-link" },
  { label: "About Us", to: "/about", testId: "footer-about-link" },
  { label: "Contact Us", to: "/contact", testId: "footer-contact-link" },
  { label: "Affiliate Disclosure", to: "/affiliate-disclosure", testId: "footer-affiliate-disclosure-link" },
  { label: "Editorial Policy", to: "/editorial-policy", testId: "footer-editorial-policy-link" },
  { label: "Commercial Relationships", to: "/commercial-relationships", testId: "footer-commercial-relationships-link" },
];

export const Footer = () => (
  <footer className="bg-[#0F172A] text-slate-300" data-testid="site-footer">
    <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8">
      <div className="mb-14 border-b border-white/15 pb-12">
        <NewsletterSignup variant="footer" />
      </div>
      <div className="mx-auto max-w-4xl space-y-6 text-center">
        <p className="text-sm leading-relaxed text-slate-400" data-testid="footer-affiliate-disclaimer">
          <span className="font-bold text-slate-300">Affiliate Disclaimer:</span> VPNReviews.ai is reader-supported.
          Some links on this website are affiliate links, which means we may earn a commission if you purchase
          through them, at no additional cost to you. We currently have affiliate relationships with NordVPN,
          Surfshark, PureVPN, VeePN and AdGuard VPN. Affiliate partnerships never influence our editorial
          comparisons, rankings or recommendations. For more information, please see our{" "}
          <Link to="/affiliate-disclosure" className="font-semibold text-[#4687FF] transition-colors duration-200 hover:text-white">
            Affiliate Disclosure
          </Link>{" "}
          and{" "}
          <Link to="/editorial-policy" className="font-semibold text-[#4687FF] transition-colors duration-200 hover:text-white">
            Editorial Standards &amp; Ranking Policy
          </Link>
          .
        </p>
        <p className="text-sm leading-relaxed text-slate-400" data-testid="footer-trademark-disclaimer">
          <span className="font-bold text-slate-300">Trademark Disclaimer:</span> All trademarks, logos, product
          names and company names are the property of their respective owners. Their use on VPNReviews.ai is solely
          for identification, comparison and editorial purposes and does not imply any endorsement or affiliation
          unless expressly stated.
        </p>
      </div>
      <nav
        className="mt-12 flex flex-col flex-wrap items-start justify-center gap-x-8 gap-y-5 sm:flex-row sm:items-center lg:gap-x-10"
        data-testid="footer-links-row"
      >
        {LEGAL_LINKS.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            data-testid={l.testId}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-300 transition-colors duration-200 hover:text-white"
          >
            {l.label}
            <ChevronRight className="h-4 w-4 text-slate-500" aria-hidden="true" />
          </Link>
        ))}
      </nav>
      <div className="mt-12 border-t border-white/15 pt-8 text-center">
        <p className="text-sm text-slate-300" data-testid="footer-copyright">
          © Copyright 2026 — All Rights Reserved
        </p>
        <p className="mt-2 text-sm text-slate-400">vpnreviews.ai</p>
        <p className="mt-3 text-xs text-slate-500">
          VPNReviews.ai is an independent editorial publication.
        </p>
      </div>
    </div>
  </footer>
);
